import React, { Component, Fragment } from 'react'
import actions from './actions/root_action'
import { connect } from 'react-redux'
import { withNamespaces } from 'react-i18next'
import { compose } from 'redux'
import '../i18n'
import './main_container.scss'
import Modal from '../common/components/modal_dialog/modal_wrapper_component'
import lozad from 'lozad'
import Slider from 'react-slick'
import languageHelper from '../common/helpers/language_helper'

const categories = {
  terrace: {
    name: 'TERRACE',
    title: 'TERRACE'
  },
  villa: {
    name: 'VILLA',
    title: 'VILLA'
  },
  house: {
    name: 'HOUSE',
    title: 'HOUSE'
  },
  willstyle: {
    name: 'HOUSE x WILL STYLE',
    title: 'HOUSE x WILL STYLE'
  },
  motel: {
    name: 'MOTEL',
    title: 'MOTEL'
  },
  collab: {
    name: 'Collaboration',
    title: 'Collaboration'
  },
  others: {
    name: 'Others',
    title: 'Others'
  }
}

const categoryDescriptions = (t) => {
  return {
    terrace: t('categoryDescriptions.terrace'),
    villa: t('categoryDescriptions.villa'),
    house: t('categoryDescriptions.house'),
    willstyle: t('categoryDescriptions.willstyle'),
    motel: t('categoryDescriptions.motel'),
    collab: t('categoryDescriptions.collab'),
    others: t('categoryDescriptions.others')
  }
}

const additionalProperties = {
  ja: [
    {
      href: 'https://vacation-stay.jp/search?room_group_id=136714&room_group_id=141094&room_group_id=141093&room_group_id=141095&feature_title=%E3%81%8A%E8%B2%B7%E3%81%84%E3%82%82%E3%81%AE%E3%83%91%E3%83%B3%E3%83%80%E3%83%AB%E3%83%BC%E3%83%A0%EF%BC%88Rakuten%20STAY%20%E6%9D%B1%E4%BA%AC%E6%B5%85%E8%8D%89%EF%BC%89',
      image: '/assets/image/top_new/rstay/tokyo-asakusa-panda.jpg',
      location: '東京都 墨田区',
      title: 'お買いものパンダルーム（Rakuten STAY 東京浅草）',
      category: 'Collaboration',
      spec: '定員1～2名・寝室1室・寝具1～2組・浴室1室・12～15m²'
    },
    {
      href: 'https://vacation-stay.jp/search?room_group_id=628603&room_group_id=628612&room_group_id=460543&room_group_id=460494&feature_title=%E3%81%8A%E8%B2%B7%E3%81%84%E3%82%82%E3%81%AE%E3%83%91%E3%83%B3%E3%83%80%E3%83%AB%E3%83%BC%E3%83%A0%EF%BC%88Rakuten%20STAY%20%E7%A6%8F%E5%B2%A1%E8%96%AC%E9%99%A2%EF%BC%89',
      image: '/assets/image/top_new/rstay/fukuokayakuin-panda.jpg',
      location: '福岡県 福岡市',
      title: 'お買いものパンダルーム（Rakuten STAY 福岡薬院）',
      category: 'Collaboration',
      spec: '定員2～8名・寝室1室・寝具2～4組・浴室1室・25.35～34.95m²'
    }
  ],
  en: [
    {
      href: 'https://vacation-stay.com/search?room_group_id=136714&room_group_id=141094&room_group_id=141093&room_group_id=141095&feature_title=Okaimono%20Panda%20Room%20%28Rakuten%20STAY%20Tokyo%20Asakusa%29',
      image: '/assets/image/top_new/rstay/tokyo-asakusa-panda.jpg',
      location: '',
      title: 'Okaimono Panda Room (Rakuten STAY Tokyo Asakusa)',
      category: 'COLLAB',
      spec: '1~2 guests, 1 bedroom, 1~2 beds, 1 bathroom, 12~15m²'
    },
    {
      href: 'https://vacation-stay.com/search?room_group_id=628603&room_group_id=628612&room_group_id=460543&room_group_id=460494&feature_title=Okaimono%20Panda%20Room%20%28Rakuten%20STAY%20Fukuoka%20Yakuin%29',
      image: '/assets/image/top_new/rstay/fukuokayakuin-panda.jpg',
      location: 'Fukuoka',
      title: 'Okaimono Panda Room (Rakuten STAY Fukuoka Yakuin)',
      category: 'COLLAB',
      spec: '2~8 guests, 1 bedroom, 2~4 beds, 1 bathroom, 25.35~34.95m²'
    }
  ]
}

const observer = lozad()

export class Main extends Component {
  constructor(props) {
    super(props)
    this.state = {
      count: 0,
      properties: {},
      selectedKey: 'all',
      isPropertyLoaded: false,
      isCouponCodeShown: false,
      brandNewProperties: []
    }
  }

  componentDidMount() {
    const properties = JSON.parse(document.getElementById('js-rs-data').getAttribute('data'))
    this.setState({ count: properties.length })

    const now = new Date()
    const dateSixMonthAgo = now.setMonth(now.getMonth() - 6)

    const brandNewProperties = properties.filter( property => new Date(property.opened_at.replace(/-/g, "/")) > dateSixMonthAgo )

    const groupedProperties = groupByKey(properties, 'category')
    groupedProperties[categories.collab.name] =
      groupedProperties[categories.collab.name]
        .concat(additionalProperties[languageHelper.pageLocale])

    this.setState({
      properties: groupedProperties,
      brandNewProperties: brandNewProperties,
      isPropertyLoaded: true
    })
  }

  componentDidUpdate() {
    observer.observe()
  }

  handleClick = key => {
    this.setState({ selectedKey: key })
  }

  render() {
    const t = this.props.t

    const settings = {
      className: 'center',
      dots: false,
      infinite: true,
      centerMode: true,
      centerPadding: '10%',
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 4000,
      cssEase: 'ease',
      arrows: false,
      draggable: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipeToSlide: false,
      swipe: false,
      touchMove: false
    }

    const imageDir = '/assets/image/rakuten_stay'

    // クーポン 2021.9.8 00:00~ 表示, 2021.9.21 10:00 非表示
    const now = new Date()
    const isCouponShown = new Date('2021/09/08 00:00:00+09:00') <= now && now < new Date('2021/09/21 10:00:00+09:00')

    return (
      <React.Fragment>
        <div styleName='top-visual'>
          <Slider {...settings}>
            <div styleName='slide' className='lozad' data-background-image={`${imageDir}/carousel/9.jpg`}>
              <div styleName='caption'></div>
            </div>
            <div styleName='slide' className='lozad' data-background-image={`${imageDir}/carousel/1.jpg`}>
              <div styleName='caption'></div>
            </div>
            <div styleName='slide' className='lozad' data-background-image={`${imageDir}/carousel/2.jpg`}>
              <div styleName='caption'></div>
            </div>
            <div styleName='slide' className='lozad' data-background-image={`${imageDir}/carousel/3.jpg`}>
              <div styleName='caption'></div>
            </div>
            <div styleName='slide' className='lozad' data-background-image={`${imageDir}/carousel/4.jpg`}>
              <div styleName='caption'></div>
            </div>
            <div styleName='slide' className='lozad' data-background-image={`${imageDir}/carousel/5.jpg`}>
              <div styleName='caption'></div>
            </div>
            <div styleName='slide' className='lozad' data-background-image={`${imageDir}/carousel/6.jpg`}>
              <div styleName='caption'></div>
            </div>
            <div styleName='slide' className='lozad' data-background-image={`${imageDir}/carousel/7.jpg`}>
              <div styleName='caption'></div>
            </div>
            <div styleName='slide' className='lozad' data-background-image={`${imageDir}/carousel/8.jpg`}>
              <div styleName='caption'></div>
            </div>
          </Slider>
          <div styleName='logo'>
            <div styleName='logo-container'>
              <div>{t('tagLine')}</div>
              <img src={`${imageDir}/logo-r-stay.svg`} alt='Rakuten STAY'/>
            </div>
          </div>
        </div>
        <div styleName='content'>
          <p styleName='brand-description' style={{ whiteSpace: "pre-line" }}>{t('brandDescription')}</p>
          {/* <a href='https://stay.rakuten.co.jp/' rel='noopener noreferrer' ratget='_blank'>
            ブランドサイトへ
          </a> */}
        </div>
        {isCouponShown &&
          <section styleName='coupon'>
            <div styleName='content'>
              <div styleName='coupon-card'>
                <div styleName='label'>SPECIAL OFFER</div>
                <div styleName='coupon-body'>
                  <div styleName='title'>敬老の日キャンペーン</div>
                  <div styleName='description'>すべてのRakuten STAYが1,000円OFF!!</div>
                  {this.state.isCouponCodeShown
                    ? <React.Fragment>
                      <div styleName='coupon-code'>
                        RSRFTAD2021
                      </div>
                      <div styleName="conditions">
                        <dl>
                          <dt>クーポン利用可能期間: </dt>
                          <dd>2021年9月8日 00:00 ～ 2021年9月21日 10:00</dd>
                        </dl>
                        <dl>
                          <dt>宿泊可能期間: </dt>
                          <dd>2021年9月9日 チェックイン ～ 2021年12月28日 チェックアウト</dd>
                        </dl>
                        <dl>
                          <dt>利用条件: </dt>
                          <dd>
                            ・10,000円(税込)以上の予約料金<br/>
                            ・他割引との併用不可
                          </dd>
                        </dl>
                        <dl>
                          <dt>利用方法: </dt>
                          <dd>予約内容確認画面でクーポンコードを入力、適用してください</dd>
                        </dl>
                      </div>
                    </React.Fragment>
                    : <div id='show-coupon-code' styleName='coupon-code-button' onClick={(e) => {
                      this.setState({
                        isCouponCodeShown: !this.state.isCouponCodeShown
                      })
                    }}>
                      クーポンコードを表示する
                    </div>
                  }
                </div>
              </div>
            </div>
          </section>
        }
        <div styleName='content'>
          {(this.state.isPropertyLoaded && this.state.brandNewProperties.length > 0) &&
            <Fragment>
              <div styleName='num-of-rs'>
                <div>
                  <span styleName='red' style={{margin: 0}}>NEW OPENING</span>
                </div>
              </div>
              <p styleName='new-opening-sub-title' style={{margin: '-48px 0 32px'}}>{t('newOpening')}</p>
              <ul styleName='new-opening'>
                {this.state.brandNewProperties.map(property => {
                  const openDate = new Date(property.opened_at.replace(/-/g, "/"))

                  return (
                    <li key={property.title} styleName='property-item'>
                      <a href={property.href} id={property.title} className='ga-rs-link' target='_blank'>
                        <div className='lozad' src='' data-background-image={property.image} styleName='thumbnail' />
                        <div styleName='location'>
                          <span className='vs-icon-pin'></span>
                          <span>{property.location}</span>
                        </div>
                        <div>
                          <div styleName='title'>{property.title}</div>
                          <div styleName='spec'>{property.spec}</div>
                          {/* <div styleName='open-date'>{`${openDate.getFullYear()}年${openDate.getMonth() + 1}月${openDate.getDate()}日より予約受付中`}</div> */}
                        </div>
                      </a>
                    </li>
                  )
                })}
              </ul>
            </Fragment>
          }
          <div styleName='num-of-rs'>
            <div>
              {languageHelper.pageLocale === "ja"
                ? <Fragment>
                  <span styleName='red'>Rakuten STAY</span>は全国に<span styleName='count'>{this.state.count}</span>施設
                </Fragment>
                : <Fragment>
                  <span styleName='count'>{this.state.count}</span>  <span styleName='red'>Rakuten STAY</span>destinations nationwide
                </Fragment>
              }
            </div>
          </div>
          <nav styleName='category-filter'>
            <button onClick={this.handleClick.bind(this, 'all')} data-selected={this.state.selectedKey == 'all'}>
              <span>ALL</span>
              <span styleName='count'>({this.state.count})</span>
            </button>
            {Object.keys(categories).map( key => {
              return (
                <button key={key} onClick={this.handleClick.bind(this, key)} data-selected={this.state.selectedKey == key}>
                  <span>{categories[key].name}</span>
                  {this.state.isPropertyLoaded &&
                    <span styleName='count'>({this.state.properties[categories[key].name].length})</span>
                  }
                </button>
              )
            })}
          </nav>
          {this.state.isPropertyLoaded &&
            accommodations(this.state.selectedKey, this.state.properties, t)
          }
        </div>
        <Modal />
      </React.Fragment>
    )
  }
}

const accommodations = (selectedKey, list, t) => {
  if (selectedKey == 'all') {
    return (
      <React.Fragment>
        {Object.keys(categories).map( key => {
          return categoryGroup(list[categories[key].name], key, t)
        })}
      </React.Fragment>
    )
  } else {
    return categoryGroup(list[categories[selectedKey].name], selectedKey, t)
  }
}

const categoryGroup = (list, key, t) => {
  const category = categories[key]
  return (
    <section key={key} styleName='category-group'>
      <div styleName='heading'>
        <h2>{category.title}</h2>
        <p>{categoryDescriptions(t)[key]}</p>
      </div>
      <ul styleName='property-list'>
        {list.map(property => {
          return (
            <li key={property.title} styleName='property-item'>
              <a href={property.href} id={property.title} className='ga-rs-link' target='_blank'>
                <div className='lozad' src='' data-background-image={property.image} styleName='thumbnail' />
                <div styleName='location'>
                  <span className='vs-icon-pin'></span>
                  <span>{property.location}</span>
                </div>
                <div>
                  <div styleName='title'>{property.title}</div>
                  <div styleName='spec'>{property.spec}</div>
                </div>
              </a>
            </li>
          )
        })}
      </ul>
    </section>
  )
}

const groupByKey = (list, key) =>
  list.reduce((hash, obj) =>
    ({...hash, [obj[key]]: ( hash[obj[key]] || [] ).concat(obj)}), {})

const mapStateToProps = state => {
  return {
    login: state.login,
    language: state.language,
    modal: state.modal,
    search: state.search,
    propertyTypes: state.propertyTypes
  }
}

const mapDispatchToProps = (dispatch, state) => {
  return {
    actions: actions(dispatch)
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNamespaces('rakuten_stay')
)(Main)
